// extracted by mini-css-extract-plugin
export var defaultWrapper = "_h6-3";
export var downloadButton = "_h6-4";
export var fileContainer = "_h6-9 _h6-7";
export var fileContainerBase = "_h6-7";
export var fileContainerBaseSm = "_h6-a _h6-7";
export var fileContainerFixedHeight = "_h6-8 _h6-7";
export var fileContainerFixedHeightSm = "_h6-c _h6-a _h6-7";
export var fileContainerSm = "_h6-b _h6-a _h6-7";
export var fileInfo = "_h6-5";
export var fileInfoWidthRestricted = "_h6-6";
export var fileType = "_h6-1";
export var fileTypeName = "_h6-2";
export var fileTypeSm = "_h6-d _h6-1";
export var image = "_h6-0";
export var link = "_h6-f";
export var overflowEllipsis = "_h6-e";